import { useState } from "react";
import { Scanner } from '@yudiel/react-qr-scanner';

export default function ServiceSettlement(props) {

  // const [scanTarget, setScanTarget] = useState(props.service.extraData["scantarget"] ?? "");
  const [scanner, setScanner] = useState(props.service.extraData["scanner"] ?? "");
  const [moneybag1, setMoneybag1] = useState(props.service.extraData["moneybag1"] ?? "");
  const [moneybag2, setMoneybag2] = useState(props.service.extraData["moneybag2"] ?? "");
  const [moneybag3, setMoneybag3] = useState(props.service.extraData["moneybag3"] ?? "");
  const [moneybag4, setMoneybag4] = useState(props.service.extraData["moneybag4"] ?? "");

  let pattern = /[0-9]{8}/g;
  let scanTarget = "";

  const moneybags = (name, value, storeFunction) => {
    if (props.service.extraData === undefined) props.service.extraData = [];
    let newValue = value.match(pattern);
    if (newValue !== null) {
      props.service.extraData[name] = value;
      props.service.extraData = { 'moneybag1': props.service.extraData['moneybag1'], 'moneybag2': props.service.extraData['moneybag2'], 'moneybag3': props.service.extraData['moneybag3'], 'moneybag4': props.service.extraData['moneybag4'] };
      props.updateExtraData(props.service.extraData);
    }
    storeFunction(value);
  }

  let content;
  if (props.service.description != '') {
    content = <div>
      <h4 className='ui header'>Beschreibung</h4>
      {props.service.description}
      <div className='ui divider'></div>
    </div>
  }
  let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  const handleScan = (detectedCodes) => {
    switch (scanTarget) {
      case "moneybag1":
        moneybags("moneybag1", detectedCodes[0].rawValue, setMoneybag1);
        setMoneybag1(detectedCodes[0].rawValue);
        break;
      case "moneybag2":
        moneybags("moneybag2", detectedCodes[0].rawValue, setMoneybag2);
        setMoneybag2(detectedCodes[0].rawValue);
        break;
      case "moneybag3":
        moneybags("moneybag3", detectedCodes[0].rawValue, setMoneybag3);
        setMoneybag3(detectedCodes[0].rawValue);
        break;
      case "moneybag4":
        moneybags("moneybag4", detectedCodes[0].rawValue, setMoneybag4);
        setMoneybag4(detectedCodes[0].rawValue);
        break;
    }
    setScanner("");
  };

  const showScanner = (e, mb) => {
    e.preventDefault();
    scanTarget = mb;
    setScanner(<Scanner onScan={handleScan}
      components={{
        torch: true, // Show torch/flashlight button (if supported)
        zoom: true, // Show zoom control (if supported)
        finder: true, // Show finder overlay
      }}
      onError={(error) => console.error(error)} />)
  }

  return (
    <div>
      {content}
      Kasseninhalt: {Euro.format(props.machine.ca302 + props.machine.ca304)}<br />
      <br />
      {props.machine.ca302>0 ? <p><i className="coins icon"></i> Denken Sie daran, die Münzen aus der Kasse zu entnehmen</p> : ''}
      {props.machine.ca304>0 ? <p><i className="money bill icon"></i> Denken Sie daran, die Scheine aus der Kasse zu entnehmen</p> : ''}
      Wenn Sie die Geldentnahme durchgeführt haben, können Sie hier die verwendeten Geldsäcke erfassen:
      {scanner}
      <form className="ui large form">
        <div className="field">
          <div className="ui left icon action input">
            <i className="barcode icon"></i>
            <input type="tel" name="moneybag1" pattern="[0-9]{8}" placeholder="" value={moneybag1} onChange={e => moneybags(e.target.name, e.target.value, setMoneybag1)} />
            <button className="ui button" onClick={e => showScanner(e, "moneybag1")}>Scan</button>
          </div>
        </div>
        <div className="field">
          <div className="ui left icon action input">
            <i className="barcode icon"></i>
            <input type="tel" name="moneybag2" pattern="[0-9]{8}" placeholder="" value={moneybag2} onChange={e => moneybags(e.target.name, e.target.value, setMoneybag2)} />
            <button className="ui button" onClick={e => showScanner(e, "moneybag2")}>Scan</button>
          </div>
        </div>
        <div className="field">
          <div className="ui left icon action input">
            <i className="barcode icon"></i>
            <input type="tel" name="moneybag3" pattern="[0-9]{8}" placeholder="" value={moneybag3} onChange={e => moneybags(e.target.name, e.target.value, setMoneybag3)} />
            <button className="ui button" onClick={e => showScanner(e, "moneybag3")}>Scan</button>
          </div>
        </div>
        <div className="field">
          <div className="ui left icon action input">
            <i className="barcode icon"></i>
            <input type="tel" name="moneybag4" pattern="[0-9]{8}" placeholder="" value={moneybag4} onChange={e => moneybags(e.target.name, e.target.value, setMoneybag4)} />
            <button className="ui button" onClick={e => showScanner(e, "moneybag4")}>Scan</button>
          </div>
        </div>
      </form>
      Haben Sie die Geldentnahme durchgeführt?<br />
      <br />
      <strong>Drücken Sie die E-Taste am Vencube, sobald Sie die Entnahme durchgeführt haben.</strong>

    </div>

  );
}